// extracted by mini-css-extract-plugin
export var contained = "CallToAction-module--contained--7db9c";
export var medium = "CallToAction-module--medium--ea5a4";
export var outlined = "CallToAction-module--outlined--ecf30";
export var primary = "CallToAction-module--primary--e74a6";
export var root = "CallToAction-module--root--ecd2e";
export var small = "CallToAction-module--small--d6d97";
export var text = "CallToAction-module--text--39722";